import { attachVerbs, ajax as ajx, buildUrl } from 'rise-ui/utils/ajax.js';

export const textErrors = {
  'The requested URL was rejected': 'url',
};

export const parseTextErrors = response => {
  for (const text in textErrors) {
    if (response.includes(text)) {
      throw textErrors[text];
    }
  }
};

export const parseJsonErrors = response => {
  // F5 returns 200 OK for errors, though the server's error JSON response is preserved
  if (response?.status === 'fail' || response?.status === 'failed' || response?.status === 'error') {
    throw response.reason;
  }
};

export const riseParseResponse = response => {
  try {
    response = JSON.parse(response);
  } catch (err) {
    parseTextErrors(response);
    throw err;
  }
  parseJsonErrors(response);
  return response;
};

export const riseParseFetch = async response => {
  return riseParseResponse(await response.text());
};

export const defaultRiseAjaxOptions = {
  parseResponse: riseParseFetch,
};

export function ajax(defaultOptions = {}) {
  return ajx({
    ...defaultOptions,
    ...defaultRiseAjaxOptions,
  });
}
attachVerbs(ajax, defaultRiseAjaxOptions);
ajax.buildUrl = buildUrl;
